/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentEnergyPriceResponse } from '../../models/current-energy-price-response';

export interface GetCurrentFeedInPrice$Params {
  location_id: string;
}

export function getCurrentFeedInPrice(http: HttpClient, rootUrl: string, params: GetCurrentFeedInPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentEnergyPriceResponse>> {
  const rb = new RequestBuilder(rootUrl, getCurrentFeedInPrice.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentEnergyPriceResponse>;
    })
  );
}

getCurrentFeedInPrice.PATH = '/locations/{location_id}/feed-in-price-current';
